<div class="col-sm-12 my-3 my-md-5">
    <div class="row">
        <div class="col-sm-6">
            <h2>Upload Plan</h2>
        </div>
        <div class="col-sm-6">
            <a routerLink="/ods-scan-logs" class="ml-2 btn btn-success pull-right">
                <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </a>
        </div>
    </div>
    <div class="col-sm-12 text-center" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner spinloader"></i></div>
    <div class="empty-state__message" *ngIf="nodata"> <i class="far fa-frown"></i> No records found.</div>

    <div *ngIf="!nodata">
        <div class="card col-sm-12">
            <div class="row p-3 mt-5">
                <div class="col-sm-8 border-right">
                    <form [formGroup]="odsScanForm" (submit)="updateOdsScanForm()">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">Patient Name</label>
                                    <input type="text" formControlName="patient_name" class="form-control"
                                        readonly />
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-label">Patient Age</label>
                                    <input type="number" formControlName="patient_age" class="form-control"
                                        readonly />
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">Gender</label>
                                    <mat-select placeholder="Gender" formControlName="gender" [disabled]="true">
                                        <mat-option value="Male">Male</mat-option>
                                        <mat-option value="Female">Female</mat-option>
                                    </mat-select>
                                </div>
                            
                                <div class="col-sm-6">
                                    <label class="form-label">Treatment</label>
                                    <mat-select placeholder="Select Treatment" formControlName="treatment_id"
                                        [disabled]="true" (click)="setSearchValue('treatment')">
                                        <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off"
                                            placeholder="Search" id="treatmentSearch">
                                        <mat-option value="">Select Treatment</mat-option>
                                        <mat-option [value]="treatment.id"
                                            *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                                    </mat-select>
                                </div>
                                <div class="col-sm-6" style="display: none;">
                                    <label class="form-label">Appointment Type</label>
                                    <mat-select placeholder="Select Appointment Type"
                                        formControlName="appointment_type" [disabled]="true">
                                        <mat-option [value]="1">New Scan</mat-option>
                                        <mat-option [value]="2">Re-Scan</mat-option>
                                        <mat-option [value]="3">Trust Align</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                            formControlName="pre_treatment_procedure">
                                        <span class="custom-control-label">Pre-treatment Procedure</span>
                                    </label>
                                </div>
                                <div class="col-sm-6"
                                    *ngIf="odsScanForm.controls['pre_treatment_procedure'].value==true">
                                    <label class="form-label">Pre-treatment Procedure Remarks</label>
                                    <textarea class="form-control" rows="5"
                                        formControlName="pre_treatment_procedure_remarks"></textarea>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="form-label">Select Share Type</label>
                                    <mat-select placeholder="Select Share Type" formControlName="plan_type">
                                        <mat-option>Select Type</mat-option>
                                        <mat-option [value]="1">Type 1</mat-option>
                                        <mat-option [value]="2">Type 2</mat-option>
                                        <mat-option [value]="3">Type 3</mat-option>
                                        <mat-option [value]="4">Type 4</mat-option>
                                        <mat-option [value]="5">Type 5</mat-option>
                                    </mat-select>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Position</label>
                                    <mat-select placeholder="Select Position" formControlName="position">
                                        <mat-option>Select Position</mat-option>
                                        <mat-option [value]="1">Upper teeth aligned initial position</mat-option>
                                        <mat-option [value]="2">Upper teeth aligned final position</mat-option>
                                        <mat-option [value]="3">Upper teeth alignment corrected initial
                                            position</mat-option>
                                        <mat-option [value]="4">Upper teeth alignment corrected final
                                            position</mat-option>
                                        <mat-option [value]="5">Lower teeth aligned initial position</mat-option>
                                        <mat-option [value]="6">Lower teeth aligned final position</mat-option>
                                        <mat-option [value]="7">Lower teeth alignment corrected initial
                                            position</mat-option>
                                        <mat-option [value]="8">Lower teeth alignment corrected final
                                            position</mat-option>
                                        <mat-option [value]="9">Alignment achieved initial position</mat-option>
                                        <mat-option [value]="10">Alignment achieved final position</mat-option>
                                        <mat-option [value]="11">Plan video</mat-option>
                                    </mat-select>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Upload Document</label>
                                    <input #planUploadFile type="file" class="form-control"
                                        (change)="selectfile($event)" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 m-10 pr-35">
                            <div class="list-group list-group-flush list-group-hoverable docList">
                                <div *ngFor="let upload of allUploads">

                                    <div class="row showfileblock align-items-center">
                                        <div class="col text-truncate">
                                            <a href="{{s3url}}{{upload.filepath}}" target="_blank"
                                                class="text-body d-block">
                                                <span class="ft-10" *ngIf="upload.plan_type"> (Type {{upload.plan_type}})</span>
                                                <!-- <span class="ft-10" *ngIf="upload.scan_type">
                                                    <span *ngIf="upload.scan_type == '1'">
                                                        (Type -==- New Scan)
                                                    </span>
                                                    <span *ngIf="upload.scan_type == '3'">
                                                        (Type -==- Trust Align)
                                                    </span>
                                                </span> -->
                                                View File</a>
                                            <a *ngIf="(myrole=='1'|| myrole=='20') && !fileDeletingLoader"
                                                class="delete-file float-right" mwlConfirmationPopover
                                                [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage"
                                                [confirmText]="confirmText" [cancelText]="cancelText"
                                                [placement]="placement" (confirm)="removeFile(upload.id)"
                                                (cancel)="cancelClicked = true" confirmButtonType="danger"
                                                cancelButtonType="outline-secondary"
                                                (click)="confirmClicked = false; cancelClicked = false"
                                                [appendToBody]="true"><i class="fa fa-trash text-danger"></i></a>

                                            <i *ngIf="fileDeletingLoader"
                                                class="fa fa-spin fa-spinner float-right text-danger"></i>

                                            <span class="badge badge-success" *ngIf='upload.position==1'>Upper teeth
                                                aligned initial position</span>
                                            <span class="badge badge-info" *ngIf='upload.position==2'>Upper teeth
                                                aligned final position</span>
                                            <span class="badge badge-success" *ngIf='upload.position==3'>Upper teeth
                                                alignment corrected initial
                                                position</span>
                                            <span class="badge badge-primary" *ngIf='upload.position==4'>Upper teeth
                                                alignment corrected final
                                                position</span>
                                            <span class="badge badge-info" *ngIf='upload.position==5'>Lower teeth
                                                aligned initial position</span>
                                            <span class="badge badge-success" *ngIf='upload.position==6'>Lower teeth
                                                aligned final position</span>
                                            <span class="badge badge-primary" *ngIf='upload.position==7'>Lower teeth
                                                alignment corrected initial
                                                position</span>
                                            <span class="badge badge-info" *ngIf='upload.position==8'>Lower teeth
                                                alignment corrected final
                                                position</span>
                                            <span class="badge badge-success" *ngIf='upload.position==9'>Alignment
                                                achieved initial position</span>

                                            <span class="badge badge-primary" *ngIf='upload.position==10'>Alignment
                                                achieved final position</span>
                                            <span class="badge badge-info" *ngIf='upload.position==11'>Plan
                                                video</span>
                                            <small
                                                class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">Upper Aligner</label>
                                    <input type="number" formControlName="upper_aligners" class="form-control" />
                                </div>
                                <div class="col-sm-6">
                                    <label class="form-label">Lower Aligner</label>
                                    <input type="number" formControlName="lower_aligners" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="form-label">Other Information about the treatment</label>
                                    <textarea class="form-control" rows="5"
                                        formControlName="other_information"></textarea>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                                        class="fa fa-spin fa-spinner"></i> Save</button>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- <div class="col-sm-4" *ngIf="new_scan || trust_align">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-4">
                                <mat-select placeholder="Select Type" [(ngModel)]="send_download_type">
                                    <mat-option>Select Type</mat-option>
                                    <mat-option [value]="1" *ngIf="new_scan > 10">New Scan</mat-option>
                                    <mat-option [value]="3" *ngIf="trust_align > 10">Trust Align</mat-option>
                                </mat-select>
                                <div *ngIf="type_validator_drop" class="invalid-feedback">
                                    **Type is required for Download Plan or Send Email Plan
                                </div>
                            </div>
                            <div class="col-md-4">
                                <button type="button" [disabled]="loading" (click)="validate_type(1)" class="btn btn-success">
                                    <i class="fa fa-download" aria-hidden="true"></i> Download Plan 
                                </button>
                            </div>
                            <div class="col-md-4">
                                <button type="button" [disabled]="loading" (click)="validate_type(2)" class="btn btn-primary">
                                    <span *ngIf="email_loading" ><i class="fa fa-spin fa-spinner"></i>&nbsp; &nbsp;</span>
                                    <i class="fa fa-envelope"  aria-hidden="true"></i> 
                                    <span *ngIf="email_loading"> Please Wait...</span> 
                                    <span *ngIf="!email_loading"> Send Plan</span>
                                </button>
                            </div>
                            <div class="col-sm-12" *ngIf="email_loading">
                                <br>
                                <b>***Note::</b> <span class="text-success">&nbsp; &nbsp;Please wait email sending is in process.</span>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>